/**
 * Retorna o tipo de recurso mais próximo do bloqueio mensal (maior % de uso).
 */
export function resolveCloserToBlockingType(
  consultations,
  recordingSeconds,
  consultationsLimit,
  recordingLimitSeconds,
) {
  const consultRatio = consultations / consultationsLimit
  const recordingRatio = recordingSeconds / recordingLimitSeconds
  return consultRatio >= recordingRatio ? 'consultations' : 'recordingTime'
}
